/**
 * Nuxt 3.21.9+ hydrates a prerendered page on its prerendered route (`payload.path`, which never carries a
 * query) and restores the visited URL only once the page has resolved, so a query string or hash disappears
 * from the address bar for a moment on every such visit (nuxt/nuxt#34651), which Google Ads reads as a
 * redirect. Without `payload.path` Nuxt hydrates on the visited URL straight away, as before 3.21.9: a page
 * that renders from `route.query` patches the prerendered markup during hydration instead.
 */
export default defineNuxtPlugin({
  name: 'preserve-query-on-hydration',
  // After nuxt:revive-payload (-30), which fills the payload, and before nuxt:router (-20), which reads its path
  order: -25,
  setup (nuxtApp) {
    if (!nuxtApp.payload.prerenderedAt || !(window.location.search || window.location.hash)) {
      return
    }

    delete nuxtApp.payload.path
  },
})
